module.exports = __webpack_public_path__ + "img/themes1.a3266bcd.jpg";